import React from 'react';

interface Props {
    heading: string;
    description: string;
    showIcon?: boolean;
    testId?: string;
    children: React.ReactNode;
}

export const WishlistFallbackStateTemplate = ({ heading, description, showIcon = false, testId, children }: Props) => (
    <div className='bs-wishlist-fallback-state' data-testid={testId}>
        {showIcon && <span className='bs-wishlist-fallback-state__icon' aria-hidden='true' />}
        <h2 className='bs-wishlist-fallback-state__heading'>{heading}</h2>
        <p className='bs-wishlist-fallback-state__description'>{description}</p>
        <div className='bs-wishlist-fallback-state__actions'>{children}</div>
    </div>
);
